

export const isEmpty = (value) => {
    return value === "";
}

export const isValidEmail = (value) => {
    const regex = /^[a-zA-Z0-9. _-]+@[a-zA-Z0-9. -]+\.[a-zA-Z]{2,4}$/;
    return regex.test(value)
}